// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__1-3G6","label":"LabeledBox_label__3At-S"};